import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const Hero: React.FC = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = requestAnimationFrame(() => setLoaded(true));
    return () => cancelAnimationFrame(t);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-surface">
      <div className="absolute inset-0 hero-grid opacity-40" />

      {/* Floating UI accents */}
      <div
        className={`absolute right-[8%] top-[22%] hidden xl:block transition-all duration-1000 delay-500 ${
          loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
        aria-hidden
      >
        <div className="w-48 rounded-xl border border-surface-border bg-surface-card p-4 animate-float">
          <div className="flex items-center justify-between mb-3">
            <span className="text-[10px] uppercase tracking-widest text-muted">Orders</span>
            <span className="text-xs text-primary-500 font-medium">+24%</span>
          </div>
          <div className="h-1.5 rounded-full bg-surface-border overflow-hidden">
            <div className="h-full w-3/4 rounded-full bg-primary-500" />
          </div>
          <p className="mt-3 text-2xl font-display font-semibold text-white">1,284</p>
        </div>
      </div>

      <div
        className={`absolute left-[6%] bottom-[28%] hidden xl:block transition-all duration-1000 delay-700 ${
          loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
        aria-hidden
      >
        <div className="w-44 rounded-xl border border-surface-border bg-surface-card p-4 animate-float-slow">
          <span className="text-[10px] uppercase tracking-widest text-muted">Inventory</span>
          <p className="mt-2 text-sm text-white font-medium">Live sync</p>
          <div className="mt-3 space-y-2">
            {[
              { name: 'Gift Box', level: 72, low: false },
              { name: 'Malbec', level: 24, low: true },
              { name: 'Sleeves', level: 58, low: false },
            ].map((item) => (
              <div key={item.name}>
                <div className="flex justify-between text-[9px] mb-1">
                  <span className="text-muted">{item.name}</span>
                  <span className={item.low ? 'text-amber-400' : 'text-muted'}>{item.level}%</span>
                </div>
                <div className="h-1 rounded-full bg-surface-border overflow-hidden">
                  <div
                    className={`h-full rounded-full ${item.low ? 'bg-amber-500' : 'bg-primary-500'}`}
                    style={{ width: `${item.level}%` }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-28 pb-20 text-center">
        <p
          className={`font-display text-sm md:text-base font-semibold tracking-[0.25em] uppercase text-primary-500 mb-6 transition-all duration-700 ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          Nexasolutra
        </p>

        <h1
          className={`font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-semibold text-white text-balance leading-[1.08] mb-6 transition-all duration-700 delay-100 ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          Operating Systems for Hospitality &amp; Commerce.
        </h1>

        <p
          className={`text-lg md:text-xl text-muted max-w-2xl mx-auto leading-relaxed mb-10 transition-all duration-700 delay-200 ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          Nexasolutra is a technology company building intelligent software that helps hospitality
          and commerce businesses manage operations, automate workflows, understand their customers,
          and grow more efficiently.
        </p>

        <div
          className={`flex flex-col sm:flex-row items-center justify-center gap-4 transition-all duration-700 delay-300 ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <Link to="/contact" className="btn-primary text-base px-8 py-3.5 w-full sm:w-auto">
            Book a Demo
          </Link>
          <a href="#work" className="btn-secondary text-base px-8 py-3.5 w-full sm:w-auto">
            View Our Work
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
